import styled from "@emotion/styled";
import { FC } from "react";

import { Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";

export const PickerContainerWithLabel: FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => {
  return (
    <Flex>
      <PickerLabel>{label}</PickerLabel>
      {children}
    </Flex>
  );
};

const PickerLabel = styled(Text)`
  min-width: 40px;
  margin-top: 6px;
`;
